import react from "react"

const Home = () => (
    <>

    </>
)

export default Home